import { useEffect } from 'react';

const useScrollIntoView = (ref, isScroll, deps) => {
  useEffect(() => {
    if (isScroll) {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, deps);
};

export default useScrollIntoView;
